import type { AxiosRequestHeaders } from "axios";
import { HttpMethodsEnum } from "../constants/enums";
import axiosObject from "./axios";

export type MakeRequest = {
  url: string;
  method: HttpMethodsEnum;
  data?: unknown;
  params?: unknown;
  headers?: AxiosRequestHeaders;
  signal?: AbortSignal;
};

export const makeRequest = async (req: MakeRequest) => {
  const { url, method, data, params, headers, signal } = req;
  const response = await axiosObject({
    url,
    method,
    data,
    params,
    headers,
    signal,
  });
  return response.data;
};
